import { ProjectGroupInfo } from 'api-client';
import { MetricProgressSegment } from 'components/common';
import { formatPercents } from 'formatters';
import { declOfNum } from 'utils';

/**
 * «6 проектов в сделке» — подпись, которая называет природу группы везде одинаково: в
 * строке списка, в мобильной карточке и в блоке группы на странице проекта.
 */
export const groupSizeLabel = (memberCount: number): string =>
  `${memberCount} ${declOfNum(memberCount, ['проект', 'проекта', 'проектов'])} в сделке`;

/**
 * Состав сделки для полосы, разбитой по проектам: один сегмент на проект.
 *
 * Живёт отдельно, потому что одну и ту же полосу показывают два места — строка группы в
 * списке проектов и блок группы на странице проекта, — и расходиться им нельзя.
 *
 * @param group     агрегаты по группе
 * @param currentUuid проект, который нужно выделить (открытая страница проекта)
 */
export const buildGroupSegments = (
  group: ProjectGroupInfo,
  currentUuid?: string
): Array<MetricProgressSegment> =>
  group.members.map((member) => ({
    key: member.uuid,
    share: member.sharePercentage,
    fill: member.collectedPercentage,
    highlighted: member.uuid === currentUuid,
    title: `${member.name[0].text} — собрано ${formatPercents(member.collectedPercentage, 1, true)}`,
  }));
